const lounge = [
    {
        name: "Диваны для гостиной",
        img: "./images/category/диваны для гостиной.png"
        
        
    },
    {
        name: "Кресла для гостиной",
        img: "./images/category/кресла для гостиной.png"
    },

    { 
      name: "Столы для гостиной", 
      img: "./images/category/столы для гостиной.png"
    },
    { 
      name: "Пуфы", 
      img: "./images/category/пуфы.png"
    },
    
];

export default lounge;
